import { render, staticRenderFns } from "./NewsBoard.vue?vue&type=template&id=46d5efe0&scoped=true&"
import script from "./NewsBoard.vue?vue&type=script&lang=js&"
export * from "./NewsBoard.vue?vue&type=script&lang=js&"
import style0 from "./news-board.css?vue&type=style&index=0&id=46d5efe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d5efe0",
  null
  
)

export default component.exports